module.exports = __webpack_public_path__ + "saml2.04f117.svg";